import React from 'react'
import { SpinnerCircular } from 'spinners-react'

const CircleLoad = () => {
  return (
    <SpinnerCircular size="20px" color="#fff" />
  )
}

export default CircleLoad